import Immutable from "immutable";
import * as types from "./constants";

const initialState = {
  soloUIDFetching: false,
  soloUIDLookup: {}
};

const soloLookupReducer = (state = Immutable.fromJS(initialState), action) => {
  switch (action.type) {
    case types.SOLO_UID_FETCH_REQUEST:
      return state.set("soloUIDFetching", true);

    case types.SOLO_UID_FETCH_SUCCESS:
      return state.mergeDeep({
        soloUIDFetching: false,
        soloUIDLookup: action.payload.reduce(
          // eslint-disable-next-line camelcase
          (R, { solo_unit_id, match: [firstMatch] }) => ({
            ...R,
            [solo_unit_id]: firstMatch
          }),
          {}
        )
      });

    case types.SOLO_UID_FETCH_ERROR:
      return state.merge({
        soloUIDFetching: false
      });

    default:
      return state;
  }
};

export default soloLookupReducer;
